import {createActionBarButtonAnchor} from '@github-ui/list-view/ListViewActionBar'
import {TriangleDownIcon} from '@primer/octicons-react'

export type QuickFilterProps = {
  owner: string
  query: string
  repo: string
  onQueryChange: (query: string) => void
}

export function createQuickFilterAnchor(label: string) {
  return createActionBarButtonAnchor({
    children: label,
    trailingVisual: TriangleDownIcon,
    'aria-label': `Filter by ${label.toLowerCase()}`,
  })
}
